import Swal from "sweetalert2";

export default {
  data() {
    return {
      loadingAlert: null
    };
  },
  methods: {
    showLoadingSweetAlert(message) {
      this.loadingAlert = Swal.fire({
        position: "top-end",
        icon: "warning", 
        title: "Please Wait Patiently",
        html: message,
        timer: 10000,
        showConfirmButton: false,
      });
      return this.loadingAlert;
    },
    closeLoadingAlert() {
      if (this.loadingAlert) {
        this.loadingAlert.close();
        this.loadingAlert = null;
      }
    },
    updateLoadingMessage(newMessage) {
      if (this.loadingAlert) {
        this.loadingAlert.update({
          html: newMessage
        });
      }
    }
  },
  beforeDestroy() {
    // Cleanup: close any open loading alerts when component is destroyed
    this.closeLoadingAlert();
  }
};
